export const GROUP_EVENT_MESSAGING_OPTIONS_LIMIT = 50
